import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.js%22,%22import%22:%22%22,%22arguments%22:[{%22fallback%22:[%22system-ui%22,%22sans-serif%22],%22src%22:%22../fonts/Gotham-Bold.woff2%22,%22style%22:%22normal%22,%22weight%22:%22700%22}],%22variableName%22:%22gothamBold%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'gothamBold', 'gothamBold Fallback', system-ui, sans-serif",
        fontWeight: 700,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
